module.exports = __webpack_public_path__ + "media/lifestyle_home/secrets_callout4-9aff8329.jpg";